import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { looseDiamondId, looseStoneId } from "utils/helpers";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import { useSelector } from "react-redux";
import zIndex from "@mui/material/styles/zIndex";

const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "35px",
    height: "30px",
    width: "200px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
    zIndex: 999,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "100px", // Ensures the dropdown has a scrollable height
    overflowY: "auto", // Enables scrolling for overflow
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const InvoiceWholeSaleSummary = ({
  skus,
  setIsSummaryOpen,
  setValue,
  setEditValues,
  setEdit,
  addSku,
}) => {
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;

  const apiService = new GetApiService(clientCode);

  const fetchData = async () => {
    try {
      console.log("workig");
      const res = await apiService.fetchAllLabelledStock();
      const result = res.filter((item) => item?.Status != "Sold");
      console.log(res);

      return result;
    } catch (error) {
      throw new Error(`Failed to fetch dropdown list data: ${error.message}`);
    }
  };
  const {
    data: labeledStockList,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["getLabeledStock"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  console.log(skus);
  const [total, setTotal] = useState({
    TotalStoneWt: 0,
    TotalStonePieces: 0,
    TotalStoneAmount: 0,
  });
  const [invoiceItem, setInvoiceItem] = useState();
  console.log(invoiceItem);
  const handleDelete = (id) => {
    setValue(
      "skus",
      skus.filter((sku) => sku.id !== id)
    );
  };
  const handleEdit = (item, index) => {
    // const data = skus.find((_,i) => i != index);
    // console.log(data)
    console.log({ ...item, index });
    const data = {
      ...item,

      StockKeepingUnit: { value: item?.SKUId, label: item?.SKU },
      CategoryId: { value: item?.CategoryId, label: item?.CategoryName },
      ProductId: { value: item?.ProductId, label: item?.ProductName },
      DesignId:{value:item?.DesignId,label:item?.DesignName},
      PurityId: { value: item?.PurityId, label: item?.PurityName },
      TotalWt:item?.TotalWeight,
      PackingWt:item?.PackingWeight,
      GrossWt:item?.GrossWt,
      StoneWt:item?.TotalStoneWeight,
      DiamondWeight:item?.TotalDiamondWeight || item?.DiamondWeight || "",
      NetWt: item?.NetWt,
      GoldRate:item?.MetalRate,
      Qty:item?.Quantity || item?.Pieces,
      FinePercent:item?.FinePercent,
      MakingPercent:item?.MakingPercentage,
      MakingPerGram:item?.MakingPerGram,
      MakingFixedAmt:item?.MakingFixedAmt,
      MakingFixedWastage:item?.MakingFixedWastage,
      StonePieces:item?.TotalStonePieces,
      StoneAmount:item?.TotalStoneAmount || "",
      Hallmark: item?.HallmarkAmount,
      MetalAmount:item?.MetalAmount,
      CuttingGrossWt:item?.CuttingGrossWt,
      CuttingNetWt:item?.CuttingNetWt,
      MRP:item?.MRP,
      index,
    };
    console.log(data)
    setEditValues(data);
    setEdit(true);
    setIsSummaryOpen(false);
  };

  useEffect(() => {
    let totalFineMetal = 0;
    let totalWt = 0;
    let GrossWt = 0;
    let TotalStoneWeight = 0;
    let NetWt = 0;
    let FinePercent = 0;
    let WastagePercent = 0;
    let stonePieces = 0;
    let TotalStoneAmount = 0;
    let TotalQty = 0;
    let TotalHallmarkAmount = 0;
    let TotalPackingWt = 0;
    let TotalDiamondwt = 0;
    let TotalMRP = 0;
    let TotalItemAmount = 0;

    skus?.forEach((item) => {
      totalFineMetal += +item?.FineWastageWt;
      totalWt += +item?.TotalWeight;
      GrossWt += +item?.GrossWt;
      TotalStoneWeight += +item?.TotalStoneWeight;
      NetWt += +item?.NetWt;
      FinePercent += +item?.FinePercent;
      WastagePercent += +item?.WastagePercent;
      TotalStoneAmount += +item?.TotalStoneAmount;
      TotalQty += +item?.Quantity || +item?.Pieces;
      TotalHallmarkAmount += +item?.HallmarkAmount;
      TotalPackingWt += +item?.PackingWeight;
      TotalDiamondwt += +item?.TotalDiamondWeight;
      TotalMRP += +item?.MRP;
      TotalItemAmount += (item?.TotalItemAmount ? +item?.TotalItemAmount : 0)
    });
    setValue("TotalFineMetal", (totalFineMetal || 0)?.toFixed(3));
    setValue("TotalTaxableAmount", (TotalItemAmount || 0)?.toFixed(2));
    setTotal({
      TotalFineMetal: totalFineMetal ? totalFineMetal : 0,
      TotalStoneWt: totalWt ? totalWt : 0,
      TotalGrossWt:GrossWt ? GrossWt:0,
      TotalStoneWeight:TotalStoneWeight ? TotalStoneWeight : 0,
      TotalStonePieces: stonePieces ? stonePieces : 0,
      NetWt: NetWt ? NetWt : 0,
      FinePercent: FinePercent ? FinePercent : 0,
      WastagePercent: WastagePercent ? WastagePercent : 0,
      TotalStoneAmount: TotalStoneAmount ? TotalStoneAmount : 0,
      TotalQty: TotalQty ? TotalQty : 0,
      TotalHallmarkAmount: TotalHallmarkAmount ? TotalHallmarkAmount : 0,
      TotalPackingWt: TotalPackingWt ? TotalPackingWt : 0,
      TotalDiamondwt: TotalDiamondwt ? TotalDiamondwt : 0,
      TotalMRP: TotalMRP ? TotalMRP : 0,
      TotalItemAmount:TotalItemAmount ? TotalItemAmount : 0
    });
  }, [skus]);
 console.log(skus[0])
  return (
    <div className="box1-section">
      <div
        className="table-container"
        style={{
          overflowX: "auto",
          margin: "0",
          padding: "0",
          width: "100%",
          minHeight: "35vh",
        }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "12px",
                  width: "300px", 
                  minWidth: "300px",
                  textAlign: "left",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Item Details
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
               
                }}
              >
                Total Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Gross Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Stone Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Net Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Fine %
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Wastage %
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                F + W Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Rate/Gm
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Stone Amt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
              Qty
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
              Hallmark Amt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Total Item Amt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Packing Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Diamond Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                MRP
              </th>
            </tr>
          </thead>
          <tbody>
            {skus?.map((row, index) => (
              <tr key={row?.srNo}>
                <td style={{ textAlign: "left"}}>
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      // alignItems: "start",
                      fontSize: "12px",
                      width:"100%"
                      // gap: "5px",
                    }}
                  >
                    <Icon
                      icon="lets-icons:img-box-fill"
                      width="24"
                      height="24"
                      style={{ flex: "1", color: "#627282", cursor: "pointer" }}
                    />
                    <div style={{ flex: "1",display:"flex",alignItems:"start" }}>
                      { row?.ItemCode || ""} - {row?.SKU || "" + " -"} {row?.CategoryName || ""} - {row?.ProductName || ""}{" "}
                      - {row?.PurityName ||""}
                    </div>
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="edit"
                        onClick={() => handleEdit(row, index)}
                      >
                        <Icon
                          title="edit"
                          icon="material-symbols-light:edit-outline"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                        />
                      </div>
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="delete"
                      >
                        <Icon
                          icon="weui:delete-outlined"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                          onClick={() => {
                            handleDelete(row?.id);
                            setValue(
                              "skus",
                              skus.filter((_, i) => i !== index)
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.TotalWeight || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.GrossWt || 0)?.toFixed(3)}
                </td>
              
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.TotalStoneWeight || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.NetWt || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.FinePercent || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.MakingPercentage || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+(row?.FineWastageWt || 0))?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.MetalRate || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.TotalStoneAmount || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {+row?.Pieces || +row?.Quantity || 0}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.HallmarkAmount || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.TotalItemAmount || 0)?.toFixed(2)}
                  {/* {((+(row?.MakingPerGram || 0) * +(row?.netWeight || 0)) + +(row?.MakingFixedAmt || 0) + +(row?.HallmarkAmount || 0) + +(row?.TotalStoneAmount||0) + +(row?.DiamondAmount||0))?.toFixed(3)} */}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.PackingWeight || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.DiamondWeight || +row?.TotalDiamondWeight || 0).toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.MRP || 0).toFixed(2)}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "12px",
                    gap: "5px",
                  }}
                >
                  {/* <Controller
                      name={field.key}
                      control={control}
                     
                      render={({ field: controllerField }) => {
                    

                        return (
                          
                        );
                      }}
                    /> */}
                  <Select
                    options={labeledStockList?.map((item) => {
                      return {
                        value: item?.Id,
                        label: item?.ItemCode,
                        item: item,
                      };
                    })}
                    onChange={(data) => {
                      addSku(data?.item, true);
                    }}
                    isSearchable={true}
                    styles={selectStyle}
                  />
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    title="add more"
                  >
                    <Icon
                      icon="weui:add-outlined"
                      onClick={() => {
                        // reset
                        setEdit(false);
                        setIsSummaryOpen(false);
                      }}
                      width="15"
                      height="15"
                      style={{ color: "#627282", cursor: "pointer" }}
                    />
                  </div>
                </div>
              </td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                Total
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalStoneWt || 0)?.toFixed(3) }
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalGrossWt || 0)?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalStoneWeight || 0)?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.NetWt || 0)?.toFixed(3) }
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalStoneAmount || 0)?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalQty || 0)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalHallmarkAmount || 0)?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalItemAmount )?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalPackingWt || 0)?.toFixed(2)}
              </td>
               <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalDiamondwt || 0)?.toFixed(3)}
              </td>
               <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {(total?.TotalMRP || 0)?.toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceWholeSaleSummary;
